export const MAX_ERRORS_PER_NODE = 20;
export const MAX_OUTPUTS_PER_NODE = 40;
